<template>
  <div id='top'>
    <h1>Run finished</h1>
    <el-row>
      <el-col>
        <stats-card></stats-card>
        <el-card class='video' :body-style="{ height: '100%', padding: '0px' }">
          <div slot="header" class="clearfix">
            <span>Done!</span>
          </div>
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/6ktnrKG8uq4?autoplay=1&cc_load_policy=1" frameborder="0" allowfullscreen></iframe>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import StatsCard from './stats-card'

  export default {
    name: 'project-finished',
    components: {
      StatsCard
    }
  }
</script>

<style scoped>
  h1 {
    padding-left: 15px;
  }
  #top {
    margin-top: 10px;
    height:100%;
  }
  .video {
    height: 600px;
  }

</style>



// WEBPACK FOOTER //
// project-finished.vue?1ea07932